(function () {
  'use strict';
  // Old search bookmarks must not keep an invisible price filter or price sort.
  const url = new URL(location.href);
  const before = url.href;
  url.searchParams.delete('filter.v.price.gte');
  url.searchParams.delete('filter.v.price.lte');
  if (['price-ascending', 'price-descending'].includes(url.searchParams.get('sort_by'))) {
    url.searchParams.delete('sort_by');
  }
  if (url.href !== before) {
    url.searchParams.delete('page');
    location.replace(url.href);
  }
})();
